import * as React from 'react';
import ILightboxComponent, { LightboxMode, TLightboxComponent } from './ILightboxComponent';
import { classNames, renderLabel } from '@features/utils/reactFunctions';

import * as style from './LightboxComponentStyle.module.scss'

const LightboxClasses = {
  lightboxStyles: {
    backdrop: 'lightboxBackdrop',
    header: 'header',
  },
  documentPreview: {
    backdrop: 'documentPreviewBackdrop',
    header: 'documentPreviewHeader',
    filename: 'documentPreviewFilename',
  },
};

export class LightboxComponent extends React.Component<ILightboxComponent, TLightboxComponent> {
  state: TLightboxComponent = {
    mode: LightboxMode.lightboxStyles,
  };

  private wrappedRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

  UNSAFE_componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.setState(
      {
        mode: this.props.style || LightboxMode.lightboxStyles,
      },
      () => {
        // @ts-ignore - ongoing refactor, updating TS
        document.body.style.overflow = this.props.isVisible ? 'hidden' : null;
      }
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps: ILightboxComponent) {
    // @ts-ignore - ongoing refactor, updating TS
    document.body.style.overflow = nextProps.isVisible ? 'hidden' : null;
  }

  closeLightbox = () => {
    this.props.closePreview && this.props.closePreview();
    // @ts-ignore - ongoing refactor, updating TS
    document.body.style.overflow = null;
  }

  componentWillUnmount() {
    // @ts-ignore - ongoing refactor, updating TS
    document.body.style.overflow = null;
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: MouseEvent) => {
    if (!event || !this.wrappedRef?.current) return;
    const target = event.target as HTMLElement;
    const modalHeight = this.wrappedRef.current.clientHeight;
    const isModalWithScroll = modalHeight > (window.innerHeight * 0.75);
    const scrollbarWidth = window.innerWidth - (this.wrappedRef.current.parentElement?.clientWidth || 15);
    const isEventOverScroll = (window.innerWidth - event.clientX) <= scrollbarWidth;

    if (!this.wrappedRef.current.contains(target) && !(isModalWithScroll && isEventOverScroll)) {
      this.closeLightbox();
    }
  }

  render() {
    const { children, small, isVisible } = this.props;
    const { mode } = this.state;
    return (
      isVisible &&
      (
        <React.Fragment>
          <div
            className={
              `${small ?
                [style.lightboxBackdrop, style.lightboxSmall].join(' ') : style[LightboxClasses[mode].backdrop]}
              `}
            data-cy="lightbox-backdrop"
          >
            <div
              className={
                classNames(
                  style.lightboxContainer,
                  this.props.style === LightboxMode.documentPreview && style.lightboxContainerForDocument
                )
              }
              data-cy="lightbox-container"
              ref={this.wrappedRef}
            >
              <div className={`${style[LightboxClasses[mode].header]}`}>
                {renderLabel(this.props.header, style.title)}
                <button className={style.closeLightbox} onClick={this.closeLightbox}>&times;</button>
              </div>
              {children}
            </div>
          </div>
        </React.Fragment>
      )
    );
  }
}
